import React from 'react';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/hero/tspc-banner.png';
import rawMaterials from '../../assets/images/process/shared/raw-materials.png';
import cuttingMachine from '../../assets/images/process/cutting/cutting-machine.png';
import heatTreatment from '../../assets/images/process/shared/heat-treatment.png';
import rotaryGrinding1 from '../../assets/images/process/cutting/rotary-grinding-1.png';
import rotaryGrinding2 from '../../assets/images/process/cutting/rotary-grinding-2.png';
import barrel1a from '../../assets/images/process/cutting/barrel-1a.png';
import barrel1a2 from '../../assets/images/process/cutting/barrel-1a-2.png';
import rolleteMachine from '../../assets/images/process/cutting/rollete-machine.png';
import centerlessGrinding from '../../assets/images/process/shared/centerless-grinding.png';
import barrel2b from '../../assets/images/process/cutting/barrel-2b.png';
import washingDrying from '../../assets/images/process/shared/washing-drying.png';
import finalInspection from '../../assets/images/process/shared/final-inspection.png';
import finalPacking from '../../assets/images/process/shared/final-packing.png';
import './Process.css';

const steps = [
  { img: rawMaterials, label: 'Raw Materials' },
  { img: cuttingMachine, label: 'Cutting Machine' },
  { img: heatTreatment, label: 'Heat Treatment (SUS420J2)' },
  { img: rotaryGrinding1, label: 'Rotary Grinding Machine' },
  { img: rotaryGrinding2, label: 'Rotary Grinding Machine' },
  { img: barrel1a, label: 'Barrel 1A (Corner Cut)' },
  { img: barrel1a2, label: 'Barrel 1A (Corner Cut)' },
  { img: rolleteMachine, label: 'Rollete Machine' },
  { img: centerlessGrinding, label: 'Centerless Grinding Machine' },
  { img: barrel2b, label: 'Barrel 2B (Shaft Polishing)' },
  { img: washingDrying, label: 'Washing & Drying' },
  { img: finalInspection, label: 'Final Visual Inspection' },
  { img: finalPacking, label: 'Final Packing Operation' },
];

const CuttingProcess = () => (
  <div>
    <Hero title={<>Cutting <span className="highlight">Process</span></>} subtitle="The first process in production where stainless steel material is cut into customer specifications." backgroundImage={heroBg} />
    <section className="process section">
      <div className="container">
        <p className="section-label">Manufacturing Process</p>
        <h2 className="section-title">View Our <span className="highlight">Cutting Process</span></h2>
        <p className="process__desc">Stainless steel material is cut into its specification required by customers as simple straight cut. All machines are operated by experienced and trained operators.</p>
        <div className="process__flow">
          {steps.map((step, i) => (
            <div className="process__step" key={i}>
              <div className="process__step-number">{String(i + 1).padStart(2, '0')}</div>
              <div className="process__step-img"><img src={step.img} alt={step.label} /></div>
              <h4 className="process__step-label">{step.label}</h4>
              {i < steps.length - 1 && <div className="process__step-arrow" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default CuttingProcess;
